import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const required: string = route.data['role'];
  if (auth.userRole() === required) return true;
  // Authenticated but wrong role for this section — send to an "access denied" page,
  // not /login, so it doesn't read as a session/logout issue.
  return router.createUrlTree(['/unauthorized']);
};

